// extracted by mini-css-extract-plugin
module.exports = {"disabled":"style_disabled__3AF-h"};